<section class="cmn-innerpage-wrapper add-project-inventory">
  <h2 class="cmn-inner-heading">
    {{ accommodationId ? "Edit Accommodation" : "New Accommodation" }}
  </h2>
  <form [formGroup]="newAccommodationForm" (ngSubmit)="onSubmit()">
    <div class="chart-account-form-wrapper">
      <div class="form-wrapper">
        <label for="">Property Name <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Property Name"
            formControlName="propertyName"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newAccommodationForm.get('propertyName')!.touched &&
                newAccommodationForm.get('propertyName')!.hasError('required')
              "
              >Property name is required.</mat-error
            >
          </span>
          <span>
            <mat-error
              *ngIf="
                newAccommodationForm.get('propertyName')!.hasError('maxlength')
              "
              >Property name must be at most 50 characters long.</mat-error
            >
          </span>
        </div>
      </div>
      <div class="form-wrapper">
        <label for="">Address <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Address"
            formControlName="address"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newAccommodationForm.get('address')!.touched &&
                newAccommodationForm.get('address')!.hasError('required')
              "
              >Address is required.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Annual Rent <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Annual Rent"
            formControlName="annualRent"
            (keypress)="allowOnlyNumberWithDecimal($event)"
            (paste)="blockPaste($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newAccommodationForm.get('annualRent')!.touched &&
                newAccommodationForm.get('annualRent')!.hasError('required')
              "
              >Annual Rent is required.</mat-error
            >
          </span>
        </div>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newAccommodationForm.get('annualRent')!.touched &&
                newAccommodationForm.get('annualRent')!.hasError('min')
              "
              >Annual Rent cannot be 0.</mat-error
            >
          </span>
        </div>
      </div>

      <div class="form-wrapper">
        <label for="">Vacancies <span class="red">*</span></label>
        <mat-form-field>
          <input
            matInput
            placeholder="Enter Vacancies"
            formControlName="vacancies"
            (keypress)="allowOnlyNumbers($event)"
            (paste)="blockPasteNumbers($event)"
          />
        </mat-form-field>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newAccommodationForm.get('vacancies')!.touched &&
                newAccommodationForm.get('vacancies')!.hasError('required')
              "
              >Vacancies is required.</mat-error
            >
          </span>
        </div>
        <div class="custom-error">
          <span>
            <mat-error
              *ngIf="
                newAccommodationForm.get('vacancies')!.touched &&
                newAccommodationForm.get('vacancies')!.hasError('min')
              "
              >Vacancies cannot be 0</mat-error
            >
          </span>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-next-btn" type="submit">Save</button>
    </div>
  </form>
</section>
